<template>
    <div>
        <li :class="['created list-group-item d-flex align-items-center justify-content-between',{'deleted':list.isDelete}]" @dblclick="list.isEdit=true" >
                            <input v-if="list.isEdit" type="text" v-model="list.message" @keyup.enter="list.isEdit = false" class="form-control form-control-lg mr-2">
                            <div  class="custom-control custom-checkbox " v-else>
                                <input type="checkbox" class="custom-control-input" v-model="list.isDone">
                                <label :class="['custom-control-label',{'done':list.isDone}]"  >{{list.message}}</label>
                            </div>
                            <div class="" @click="[del(list.id),list.isDelete = true]">
                                <button class="btn btn-outline-primary">Delete <i class="icofont-ui-delete"></i></button>
                                
                            </div>

                        </li>
    </div>
</template>

<script>
    export default {
        name :'Listcreate',
        
        props : {
            list : {
                type : Object,
                required : true
            }
        },
        methods: {
            del(x) {
                this.$emit("del",x);
               
            }
        },
    }
</script>

<style lang="scss" scoped>

</style>